/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FriendStatus } from './FriendStatus';
import {
    FriendStatusFromJSON,
    FriendStatusFromJSONTyped,
    FriendStatusToJSON,
    FriendStatusToJSONTyped,
} from './FriendStatus';

/**
 * Friend entry with populated user data
 * @export
 * @interface IFriendEntryResponse
 */
export interface IFriendEntryResponse {
    /**
     * 
     * @type {string}
     * @memberof IFriendEntryResponse
     */
    odId?: string;
    /**
     * 
     * @type {FriendStatus}
     * @memberof IFriendEntryResponse
     */
    status?: FriendStatus;
    /**
     * 
     * @type {number}
     * @memberof IFriendEntryResponse
     */
    requestedAt?: number;
    /**
     * 
     * @type {number}
     * @memberof IFriendEntryResponse
     */
    acceptedAt?: number;
    /**
     * Custom label you assigned to this friend
     * @type {string}
     * @memberof IFriendEntryResponse
     */
    label?: string;
    /**
     * Friend's nickname from their User profile
     * @type {string}
     * @memberof IFriendEntryResponse
     */
    nickname?: string;
    /**
     * Friend's Discord username (fallback)
     * @type {string}
     * @memberof IFriendEntryResponse
     */
    discordUsername?: string;
    /**
     * 
     * @type {string}
     * @memberof IFriendEntryResponse
     */
    avatarUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IFriendEntryResponse
     */
    isOnline?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IFriendEntryResponse
     */
    currentGame?: string;
}



/**
 * Check if a given object implements the IFriendEntryResponse interface.
 */
export function instanceOfIFriendEntryResponse(value: object): value is IFriendEntryResponse {
    return true;
}

export function IFriendEntryResponseFromJSON(json: any): IFriendEntryResponse {
    return IFriendEntryResponseFromJSONTyped(json, false);
}

export function IFriendEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFriendEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'odId': json['odId'] == null ? undefined : json['odId'],
        'status': json['status'] == null ? undefined : FriendStatusFromJSON(json['status']),
        'requestedAt': json['requestedAt'] == null ? undefined : json['requestedAt'],
        'acceptedAt': json['acceptedAt'] == null ? undefined : json['acceptedAt'],
        'label': json['label'] == null ? undefined : json['label'],
        'nickname': json['nickname'] == null ? undefined : json['nickname'],
        'discordUsername': json['discordUsername'] == null ? undefined : json['discordUsername'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'isOnline': json['isOnline'] == null ? undefined : json['isOnline'],
        'currentGame': json['currentGame'] == null ? undefined : json['currentGame'],
    };
}

export function IFriendEntryResponseToJSON(json: any): IFriendEntryResponse {
    return IFriendEntryResponseToJSONTyped(json, false);
}

export function IFriendEntryResponseToJSONTyped(value?: IFriendEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'odId': value['odId'],
        'status': FriendStatusToJSON(value['status']),
        'requestedAt': value['requestedAt'],
        'acceptedAt': value['acceptedAt'],
        'label': value['label'],
        'nickname': value['nickname'],
        'discordUsername': value['discordUsername'],
        'avatarUrl': value['avatarUrl'],
        'isOnline': value['isOnline'],
        'currentGame': value['currentGame'],
    };
}

